export enum KeyCode {
	ENTER = 'Enter',
	SPACE = ' '
}
